<template>
    <div class="rating-labels d-flex align-items-center gap-1">
        <div class="fuel badge d-flex align-items-center gap-2 gap-lg-1 gap-xl-2 cursor-pointer" :class="fuel.toLowerCase()" @click="toggleInfoModal('fuel')" data-bs-toggle="modal" data-bs-target="#infoModal">
            <i class="fa-solid fa-charging-station fa-xl text-white"></i>
            <p class="mb-0">{{ fuel }}</p>
        </div>
        <div class="wet badge d-flex align-items-center gap-2 gap-lg-1 gap-xl-2 cursor-pointer" :class="wet.toLowerCase()" @click="toggleInfoModal('wet')" data-bs-toggle="modal" data-bs-target="#infoModal">
            <i class="fa-solid fa-raindrops fa-xl"></i>
            <p class="text-white mb-0">{{ wet }}</p>
        </div>
        <div class="decibel badge d-flex align-items-center gap-1 cursor-pointer bg-light" @click="toggleInfoModal('decibel')" data-bs-toggle="modal" data-bs-target="#infoModal">
            <i class="fa-solid fa-volume-low fa-xl"></i>
            <div class="d-flex align-items-center">
                <p class="mb-0">{{ decibels }}</p>
                <small v-if="noiseRating" class="d-inline-block">{{ noiseRating }}</small>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['fuel', 'wet', 'decibels', 'noiseRating'],
        methods: {
            async toggleInfoModal(type) {
                var heading = '';
                var text = '';

                if(type == 'fuel') {
                    heading = 'Fuel Rating';
                    text = '<p>Tyre fuel efficiency is rated between A and E. A rated tyres allow you to drive further with lower CO2 emissions, whilst an E rated tyre will emit more CO2 and offer a lower fuel efficiency.</p>';
                }
                else if(type == 'wet') {
                    heading = 'Wet Rating';
                    text = '<p>Wet grip is measured in classes A to E. A rated tyres offer better wet grip and short stopping distances where as an E rated tyre has less wet grip and longer stopping distances.</p>';
                }
                else if(type == 'decibel') {
                    heading = 'Decibel Rating';
                    text = '<p>Noise levels of a tyre are measured in decibels ranging from class A to C. Low noise level tyres can range between 67 and 71 dB, where as high noise level tyres show 72 to 77dB.</p>';
                }

                this.emitter.emit('openInfoModal', {heading: heading, text: text});
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@frontendAssets/sass/_variables.scss';

    .rating-labels {
        div.badge {
            color: #1a1a1a;
            border-radius: 18px;
            padding: 6px 10px;
            &.fuel {
                i, svg, p {
                    color: #222;
                }
                &.a {
                    background-color: #02983F;
                    i, svg, p {
                        color: #fff;
                    }
                }
                &.b {
                    background-color: #A1C716;
                }
                &.c {
                    background-color: #FEED01;
                }
                &.d {
                    background-color: #FCB900;
                }
                &.e, &.f, &.g {
                    background-color: #E40613;
                    i, svg, p {
                        color: #fff;
                    }
                }
            }
            &.wet {
                color: #fff;
                background-color: $blue;
                &.a {
                    background-color: #02983F;
                    i, svg, p {
                        color: #fff;
                    }
                }
            }
            p {
                margin: 0;
                text-transform: uppercase;
            }
            small {
                font-weight: bold;
                font-size: 12px;
                margin-top: 3px;
            }
        };
    }
</style>